<form #createEventoForm="ngForm">
    <app-custom-modal #modal [title]="'Adicionar evento'" [subtitle]="'Crie um novo evento em sua agenda'"
        (onCloseClick)="modal.close()" (onSaveClick)="save()" [saveLabel]="'Adicionar evento'" hideCancel
        [saveDisabled]="createEventoForm.invalid" buttonImage="hgi hgi-stroke hgi-tick-01 icon-color-black">
        <div class="container">
            <div class="mb-4">
                <label for="titulo" class="form-label required">Titulo</label>
                <input type="text" class="form-control" name="titulo" [(ngModel)]="evento.titulo" #tituloModel="ngModel"
                    #tituloEl id="titulo" required />
                <abp-validation-summary [control]="tituloModel" [controlEl]="tituloEl"></abp-validation-summary>
            </div>

            <div class="mb-4">
                <label for="data" class="form-label required">Data</label>
                <input type="date" class="form-control" name="data" [(ngModel)]="data" #dataModel="ngModel" #dataEl
                    id="data" required />
                <abp-validation-summary [control]="dataModel" [controlEl]="dataEl"></abp-validation-summary>
            </div>
            
            <div class="form-row mb-4">
                <div class="col">
                    <label for="inicio" class="form-label required">Horário Inicio</label>
                    <input type="time" [disabled]="ehDiaTodo" class="form-control" name="inicio"
                        [(ngModel)]="horaInicio" required #inicioModel="ngModel" #inicioEl id="inicio" />
                    <abp-validation-summary [control]="inicioModel" [controlEl]="inicioEl"></abp-validation-summary>
                </div>
                <div class="col">
                    <label for="fim" class="form-label required">Horário Fim</label>
                    <input type="time" [disabled]="ehDiaTodo" class="form-control" name="fim" [(ngModel)]="horaFim"
                        required #fimModel="ngModel" #fimEl id="fim" />
                    <abp-validation-summary [control]="fimModel" [controlEl]="fimEl"></abp-validation-summary>
                </div>
            </div>

            <div class="row d-flex align-items-center form-check mb-4">
                <input type="checkbox" class="form-check-input" name="evento-dia-todo" (change)="checkDiaTodo()" />
                <label class="form-check-label" for="evento-dia-todo">
                    Dia todo
                </label>
            </div>

        </div>
    </app-custom-modal>
</form>